import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca55d6d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name"]

import { ref, watch } from 'vue';

// รับ props จาก parent component

export default /*#__PURE__*/_defineComponent({
  __name: 'InputDecimal',
  props: {
  name: {
    type: String, // ชื่อ name ของ input
    required: true
  },
  modelValue: {
    type: Number, // ค่าที่รับจาก parent
    default: null, // ไม่กำหนดค่าเริ่มต้น
    required: false // อนุญาตให้เป็น null หรือ undefined ได้
  }
},
  setup(__props) {

const props = __props



// ตัวแปรเก็บค่า input
const formattedNumber = ref('');

// ฟังก์ชันสำหรับจัดการการกรอกตัวเลขทศนิยม
const formatDecimal = (event: Event) => {
  let value = (event.target as HTMLInputElement).value;
  // กรองเฉพาะตัวเลขและจุดทศนิยม
  value = value.replace(/[^0-9.]/g, '');
  
  // ตรวจสอบจำนวนจุดทศนิยม
  const decimalIndex = value.indexOf('.');
  if (decimalIndex !== -1) {
    value = value.slice(0, decimalIndex + 3); // จำกัดทศนิยมไม่เกิน 2 ตำแหน่ง
  }
  
  formattedNumber.value = value;
};

// อัพเดตค่าทศนิยมเมื่อ props เปลี่ยนแปลง (ถ้ามีค่า)
watch(() => props.modelValue, (newVal) => {
  formattedNumber.value = newVal !== null ? newVal.toFixed(2) : '';
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    name: __props.name,
    type: "text",
    class: "w-full rounded-md",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formattedNumber).value = $event)),
    onInput: formatDecimal
  }, null, 40, _hoisted_1)), [
    [_vModelText, formattedNumber.value]
  ])
}
}

})